import { css } from '@emotion/react'
import { theme } from './theme'

export const globalStyles = css`
  /* Global Resets and Base Styles */
  html, body {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  body {
    background-color: ${theme.colors.light};
    font-family: ${theme.typography.fontFamily};
    padding-top: 60px;
    color: #212529;
  }

  /* Utility classes */
  .positive {
    color: ${theme.colors.positive};
  }

  .negative {
    color: ${theme.colors.negative};
  }

  /* Animations */
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Scroll behavior */
  html {
    scroll-behavior: smooth;
  }

  /* Bootstrap overrides */
  .modal-header {
    background: linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.secondary} 100%);
    color: white;
    border-bottom: none;
  }

  .modal-body {
    padding: 30px;
  }

  .modal-footer {
    border-top: none;
    padding: 0 30px 30px;
  }

  .form-control:focus {
    border-color: ${theme.colors.primary};
    box-shadow: 0 0 0 0.25rem rgba(41, 117, 186, 0.25);
  }

  .btn-close-white {
    filter: invert(1) grayscale(100%) brightness(200%);
  }

  /* Custom scrollbar for webkit browsers */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.light};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.primary};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.secondary};
  }
`